var scope_0 = require('/home/runner/work/tuesday/tuesday/tuesday/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1c9bcbdeae26eeceb0fb71fa2325e8ed.js').default;
var scope_1 = require('/home/runner/work/tuesday/tuesday/tuesday/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/453206152e357f5afbcaf6fa772754e7.js').default;
var scope_2 = require('/home/runner/work/tuesday/tuesday/tuesday/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    